import { fetchData } from '@/utils/fetch'

export const signIn = (data) => {
  return fetchData('/appb/b2b/user/register', {
    method: 'post',
    body: JSON.stringify(data)
  })
}

export const signOut = () => {
  return fetchData('/appb/b2b/user/logOut', {
    method: 'post'
  })
}

export const sendVerifyCode = (data) => {
  return fetchData('/appb/b2b/user/verifyCode', {
    method: 'post',
    body: JSON.stringify(data)
  })
}

export const retrieveUserInfo = () => {
  return fetchData('/dsp-app/alibaba-inter/queryMyInfo', {
    method: 'post'
  })
}

export const retrieveSuperUserAddress = () => {
  return fetchData('/appb/b2b/address/get')
}

export const retrieveLanguageList = () => {
  return fetchData('/dsp-app/alibaba-common/language')
}

export const retrieveUserAllowOrderStatus = () => {
  return fetchData('/appb/alibaba-common/enableOrderStatus')
}
